import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Lista from "./Lista";
import Plano from "./Plano";

export default function Index({ match }) {
  return (
    <div className="content-wrapper">
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/lista`} />
        <Route path={`${match.url}/lista`} component={Lista} />
        <Route path={`${match.url}/:id`} component={Plano} />
      </Switch>
    </div>
  );
}
